/**
 * FIFO Allocation Drawer.
 *
 * Thin Dialog wrapper around FIFOAllocationView. Opened from the
 * item_code link on the Stock Upload → Change History sub-tab.
 *
 * The actual content lives in FIFOAllocationView so it can also be
 * embedded as a tab inside StockInputHistoryDrawer.
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import FIFOAllocationView from './FIFOAllocationView';

interface FIFOAllocationDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  partNumber: string;
  description?: string;
}

export default function FIFOAllocationDrawer({
  open, onOpenChange, partNumber, description,
}: FIFOAllocationDrawerProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle>FIFO Allocation — {partNumber}</DialogTitle>
          <DialogDescription>
            {description || 'Per-PO ledger of allocate / consume / restore events.'}
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto pr-1">
          <FIFOAllocationView partNumber={partNumber} active={open} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
